import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import Register from './pages/Register';
import Shop from './pages/Shop';
import About from './pages/About';
import Admin from './admin/Admin';
import Privacy from './pages/Privacy';
import DeleteAccount from './pages/DeleteAccount';
import TeamPage from './pages/TeamPage';
import EventPage from './pages/EventPage';
import './styles/global.css';
import emailjs from '@emailjs/browser';
emailjs.init('403pvd05zx0yDvLoX');

function Layout() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  const isDeepLink = location.pathname.startsWith('/team/') || location.pathname.startsWith('/event/');

  return (
    <>
      {!isAdmin && !isDeepLink && <Navbar />}
      <div style={!isAdmin ? { paddingTop: 0 } : {}}>
        <Routes>
          <Route path="/"                   element={<Home />} />
          <Route path="/how-it-works"       element={<HowItWorks />} />
          <Route path="/register"           element={<Register />} />
          <Route path="/shop"               element={<Shop />} />
          <Route path="/about"              element={<About />} />
          <Route path="/admin"              element={<Admin />} />
          <Route path="/admin/*"            element={<Admin />} />
          <Route path="/privacy"            element={<Privacy />} />
          <Route path="/delete-account"     element={<DeleteAccount />} />
          <Route path="/team/:id"           element={<TeamPage />} />
          <Route path="/event/:id"          element={<EventPage />} />
        </Routes>
      </div>
      {!isAdmin && !isDeepLink && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}